var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:''.concat(_vm.iconClass, ' ', _vm.additionalClass),style:(''.concat(_vm.additionalStyle))})}
var staticRenderFns = []

export { render, staticRenderFns }